import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import css from './IconCheckmarkCircle.module.css';

const IconCheckmarkCircle = props => {
  const { rootClassName, className } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <g clipPath="url(#clip0_2030_486)">
        <path
          d="M12 0C5.373 0 0 5.373 0 12c0 6.628 5.373 12 12 12 6.628 0 12-5.372 12-12 0-6.627-5.372-12-12-12m0 22.524C6.21 22.524 1.5 17.79 1.5 12S6.21 1.5 12 1.5 22.5 6.21 22.5 12 17.79 22.524 12 22.524m4.79-14.915-7.042 7.085-3.17-3.17a.75.75 0 0 0-1.061 1.06l3.712 3.712a.75.75 0 0 0 1.15-.108L17.85 8.67a.75.75 0 0 0-1.06-1.06"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_2030_486">
          <path fill="#fff" d="M0 0h24v24H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

IconCheckmarkCircle.defaultProps = {
  rootClassName: null,
  className: null,
};

const { string } = PropTypes;

IconCheckmarkCircle.propTypes = {
  rootClassName: string,
  className: string,
};

export default IconCheckmarkCircle;
